import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FunnelStepNavigationCard } from 'modules/funnels/funnel/components/funnel-step-navigation-card';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import React from 'react';
import { LONG_PRESS_DRAG_CLASS_NAME } from 'shared/hooks/use-drag-sensors';
import { twJoin } from 'tailwind-merge';
interface DraggableFunnelStepProps {
  funnelStep: FunnelStepInterface;
  selectedFunnelStep: FunnelStepInterface | null;
  selectFunnelStep: (funnelId: FunnelStepInterface) => void;
}
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
function DraggableFunnelStep(t0) {
  const $ = _c(24);
  const {
    funnelStep,
    selectedFunnelStep,
    selectFunnelStep
  } = t0;
  let t1;
  if ($[0] !== funnelStep.id) {
    t1 = {
      id: funnelStep.id,
      animateLayoutChanges
    };
    $[0] = funnelStep.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transition,
    transform
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 0.5 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== transition) {
    t4 = {
      transition,
      transform: t2,
      opacity: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = transition;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = twJoin("hover:bg-bg-tertiary focus-visible:focus-ring-primary", LONG_PRESS_DRAG_CLASS_NAME);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== funnelStep || $[10] !== selectFunnelStep) {
    t6 = () => selectFunnelStep(funnelStep);
    $[9] = funnelStep;
    $[10] = selectFunnelStep;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = selectedFunnelStep?.id === funnelStep.id;
  let t8;
  if ($[12] !== attributes || $[13] !== funnelStep || $[14] !== listeners || $[15] !== selectFunnelStep || $[16] !== setActivatorNodeRef || $[17] !== t6 || $[18] !== t7) {
    t8 = <FunnelStepNavigationCard ref={setActivatorNodeRef} {...attributes} {...listeners} className={t5} onClick={t6} funnelStep={funnelStep} selected={t7} selectFunnelStep={selectFunnelStep} />;
    $[12] = attributes;
    $[13] = funnelStep;
    $[14] = listeners;
    $[15] = selectFunnelStep;
    $[16] = setActivatorNodeRef;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== setNodeRef || $[21] !== style || $[22] !== t8) {
    t9 = <div ref={setNodeRef} style={style}>{t8}</div>;
    $[20] = setNodeRef;
    $[21] = style;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
}
export default DraggableFunnelStep;